import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  CircularProgress,
  Select,
  MenuItem,
  ListItemText,
} from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../CSS/AddFuelMeterDialog.css";

const AddMeterDialog = ({
  open,
  onClickAdd,
  onClose,
  isLoading,
  associatedCustomers,
}) => {
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [meterId, setMeterId] = useState("");
  const [meterStartReading, setMeterStartReading] = useState(0.0);

  useEffect(() => {
    setSelectedCustomer(null);
    setMeterId("");
    setMeterStartReading(0.0);
  }, [open]);

  const handleCustomerChange = (event) => {
    const selectedId = event.target.value;
    const selectedCustomer = associatedCustomers?.find(
      (customer) => customer?.id === selectedId
    );
    setSelectedCustomer(selectedCustomer);
  };

  const isValidMeter = () => {
    return !selectedCustomer || !meterId.trim() || meterStartReading < 0;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "add-fuel-meter-dialog-container",
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="add-fuel-meter-dialog-close"
          onClick={onClose}
        />
        <div className="add-fuel-meter-dialog-content">
          <div className="add-fuel-meter-dialog-title">Add Meter</div>
          <div className="add-fuel-meter-input-container">
            <label>ABO Name</label>
            <Select
              id="fbo-customer-select"
              className="add-fuel-meter-select-container"
              value={selectedCustomer?.id ?? ""}
              onChange={handleCustomerChange}
              renderValue={(selected) =>
                associatedCustomers?.find(
                  (customer) => customer?.id === selected
                )?.name
              }
            >
              {associatedCustomers?.map((customer) => (
                <MenuItem key={customer?.id} value={customer?.id}>
                  <ListItemText primary={customer?.name} />
                </MenuItem>
              ))}
            </Select>
          </div>
          <div className="add-fuel-meter-input-container">
            <label>Meter ID</label>
            <input
              name="add-fuel-meter-id"
              placeholder="Enter meter id"
              variant="outlined"
              value={meterId}
              onChange={(e) => setMeterId(e.target.value)}
            />
          </div>
          <div className="add-fuel-meter-input-container">
            <label>Fuel Meter Start Reading (gallons)</label>
            <input
              name="add-fuel-meter-start-reading"
              placeholder="Enter meter start reading"
              variant="outlined"
              type="number"
              min="0"
              value={meterStartReading}
              onChange={(e) => setMeterStartReading(e.target.value)}
            />
          </div>
          <Button
            variant="contained"
            disabled={isValidMeter()}
            onClick={
              isLoading
                ? null
                : () => onClickAdd(selectedCustomer, meterId, meterStartReading)
            }
            endIcon={
              isLoading ? <CircularProgress size={30} color="inherit" /> : null
            }
          >
            Add
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddMeterDialog;
